import { useContext } from 'react'

import { SavedFilterSelect } from '@webapp/components/SavedFilterSelect'
import { type SavedFilter } from '@webapp/models/SavedFilter'
import { SaveFilterManagerContext } from '../../SavedFilterManagerContext'

export interface ISavedFilterManagerSelectProps {
  inputId?: string
  isDisabled?: boolean
  onEdit?: () => void
  // Fires when `beforeApply` returns a promise, for example to open a
  // confirmation. Close a surrounding popover here, or it covers the modal.
  onApplyDeferred?: () => void
}

export const SavedFilterManagerSelect = ({
  inputId,
  isDisabled,
  onEdit,
  onApplyDeferred,
}: ISavedFilterManagerSelectProps) => {
  const {
    collectionId,
    applySavedFilters,
    filterManager,
    selectedSavedFilter,
    setSelectedSavedFilter,
    getScopeTags,
  } = useContext(SaveFilterManagerContext)

  const { filterTags } = filterManager

  const onChange = (value: Nullable<SavedFilter>) => {
    const previousSavedFilter = selectedSavedFilter

    setSelectedSavedFilter(value)

    if (!value) return

    const restoreWhenDeclined = (isApplied: boolean) => {
      if (!isApplied) setSelectedSavedFilter(previousSavedFilter)
    }

    const applyResult = applySavedFilters(value.filters)

    if (typeof applyResult === 'boolean') {
      restoreWhenDeclined(applyResult)
    } else {
      onApplyDeferred?.()
      void applyResult.then(restoreWhenDeclined)
    }
  }

  return (
    <SavedFilterSelect
      inputId={inputId}
      isDisabled={isDisabled}
      defaultOptions={false}
      collection={collectionId}
      filterTags={filterTags}
      getScopeTags={getScopeTags}
      value={selectedSavedFilter}
      onChange={onChange}
      onEdit={onEdit}
    />
  )
}
